import React from 'react';
import styled from 'styled-components';
import { RocketsIllustration } from 'src/assets/images';

const EntrepreunerSection: React.FC = () => {
  return (
    <Container>
      <Content>
        <TextContent>
          <Title>World needs <span>Entrepreneurs</span></Title>
          <Description>
            Startups doesn’t happen by chance; it takes bold 
            and resilient individuals to drive it forward.
          </Description>
        </TextContent>
        <RocketImage src={RocketsIllustration} alt="Rockets Illustration" />
      </Content>
    </Container>
  );
};

const Container = styled.section`
  padding: 30px 60px;
  background-color: #fafafa;
  text-align: left;

  /* Tablet styles */
  @media (max-width: 768px) {
    padding: 20px 30px;
  }

  /* Mobile styles */
  @media (max-width: 480px) {
    padding: 15px 20px;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0px;
  background: #ffffff;
  box-shadow: 0 15px 50px rgba(17, 28, 43, 0.01);
  border-radius: 12px;
  border: 0.5px solid rgba(255, 91, 36, 0.3);
  &:hover {
    border-color: #ff5924;
    box-shadow: 0 25px 60px rgba(255, 89, 36, 0.12);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 30px 20px;
  }

  @media (max-width: 480px) {
    padding: 20px 15px;
    gap: 15px;
  }
`;

const TextContent = styled.div`
  flex: 1;
  padding: 40px 50px;
  align-items: center;
  justify-content: center;
   @media (max-width: 480px) {
    padding: 20px 30px;
  }
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 16px;

  span {
    background: linear-gradient(90deg, #FF5733, #FF8C00);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Description = styled.p`
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  max-width: 500px;
`;

const RocketImage = styled.img`
  max-height: 250px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    max-height: 200px;
    max-width: 100%;
    margin-top:-30px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    margin-top:-30px;
  }
`;
const IllustrationContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default EntrepreunerSection;
